<template>
    <div id="app">
      <b-card>
        <b-card-header>
          <b-card-title>Customer Ticket Volume Analysis</b-card-title>
        </b-card-header>
        <apexchart
          type="bar"
          :height="350"
          :options="chartOptions"
          :series="series"
        />
      </b-card>
    </div>
  </template>
  
  <script>
  import VueApexCharts from "vue-apexcharts";
  import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";
  
  export default {
    name: "CustomerTicketVolumeChart",
    components: {
      apexchart: VueApexCharts,
      BCard,
      BCardHeader,
      BCardTitle
    },
    props: {
      data: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    computed: {
      // Get top 5 customers by ticket count
      topCustomers() {
        const customerTickets = this.data.reduce((acc, item) => {
          if (!acc[item.name]) {
            acc[item.name] = 0;
          }
          acc[item.name] += item.count;
          return acc;
        }, {});
  
        return Object.entries(customerTickets)
          .map(([name, count]) => ({ name, count }))
          .sort((a, b) => b.count - a.count)
          .slice(0, 5); // Only top 5 customers
      },
      series() {
        return [{
          name: "Number of Tickets",
          data: this.topCustomers.map(customer => customer.count)
        }];
      },
      chartOptions() {
        return {
          chart: {
            type: 'bar',
            height: 350
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              columnWidth: '45%',
              distributed: true
            }
          },
          dataLabels: {
            enabled: true
          },
          xaxis: {
            categories: this.topCustomers.map(customer => customer.name),
            title: {
              text: "Customers",
            },
            labels: {
              style: {
                fontSize: '12px'
              }
            }
          },
          yaxis: {
            title: {
              text: "Number of Tickets"
            }
          },
          colors: ['#1976D2', '#2196F3', '#42A5F5', '#64B5F6', '#90CAF9'],
          title: {
            text: 'Top 5 Customers by Ticket Volume',
            align: 'center',
            style: {
              fontSize: '16px'
            }
          },
          legend: {
            show: false
          }
        };
      }
    }
  };
  </script>
  
  <style scoped>
  #app {
    width: 100%;
    height: 100%;
    margin: 20px;
  }
  
  @media (max-width: 768px) {
    #app {
      margin: 10px;
    }
  }
  </style>